import Component from '@glimmer/component';

export default class LoadingSpinnerComponent extends Component {
  get size() {
    return this.args.size || 'medium';
  }

  get message() {
    return this.args.message || 'Loading...';
  }

  <template>
    <div class="loading-spinner {{this.size}}" ...attributes>
      <div class="loading-spinner__icon">
        <svg class="loading-spinner__svg" viewBox="0 0 50 50">
          <circle class="loading-spinner__circle" cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="3"/>
        </svg>
      </div>
      
      {{#if this.args.showMessage}}
        <div class="loading-spinner__message">{{this.message}}</div>
      {{/if}}
    </div>

    <style>
      .loading-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 2rem;
      }

      .loading-spinner.small {
        padding: 1rem;
        gap: 0.5rem;
      }

      .loading-spinner.large {
        padding: 3rem;
        gap: 1.5rem;
      }

      .loading-spinner__icon {
        color: #3b82f6;
      }

      .loading-spinner__svg {
        animation: loading-spinner-rotate 1s linear infinite;
      }

      .loading-spinner.small .loading-spinner__svg {
        width: 24px;
        height: 24px;
      }

      .loading-spinner.medium .loading-spinner__svg {
        width: 40px;
        height: 40px;
      }

      .loading-spinner.large .loading-spinner__svg {
        width: 56px;
        height: 56px;
      }

      .loading-spinner__circle {
        stroke-linecap: round;
        stroke-dasharray: 90, 150;
        stroke-dashoffset: 0;
        animation: loading-spinner-dash 1.5s ease-in-out infinite;
      }

      .loading-spinner__message {
        color: #6b7280;
        font-size: 0.875rem;
        text-align: center;
      }

      .loading-spinner.small .loading-spinner__message {
        font-size: 0.75rem;
      }

      .loading-spinner.large .loading-spinner__message {
        font-size: 1rem;
      }

      @keyframes loading-spinner-rotate {
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes loading-spinner-dash {
        0% {
          stroke-dasharray: 1, 150;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -35;
        }
        100% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -124;
        }
      }
    </style>
  </template>
}
